import ContentWindow from '@/components_v2/generic/styling/ContentWindow.vue';
import Card from '@/components_v2/generic/styling/Card.vue';

export {ContentWindow, Card};
